import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductBox } from '../../components/products/product-box/product-box';
import { ProductNavbar } from '../../components/products/product-navbar/product-navbar';
import { ProductSpecs } from '../../components/products/product-specs/product-specs';
import { ProductVideoBanner } from "../../components/products/product-video-banner/product-video-banner";
import { SPECS } from '../../data/products-specs.data';
import { PRODUCTS } from '../../data/products.data';
import { M4tdBoxes } from '../../m4td-boxes/m4td-boxes';

@Component({
  selector: 'app-product-page',
  imports: [ProductNavbar, ProductVideoBanner, ProductBox, ProductSpecs, M4tdBoxes],
  templateUrl: './product-page.html',
  styleUrl: './product-page.scss',
})
export class ProductPage {
    product: any;
    bannerVideo: any;
    specs: any;
    public shouldShowSpecs: boolean = false;
    @ViewChild('specsBox') specsBox!: ElementRef; 
    @ViewChild('mainBox') mainBox!: ElementRef; 

    allowedSpecsArray = [
      'matrice-400',
      'matrice-4',
      'dock3'
    ]

    constructor(private route: ActivatedRoute) {
      const slug = this.route.snapshot.paramMap.get('slug');
      this.product = PRODUCTS.find(s => s.slug === slug)
      this.bannerVideo = {
        title: this.product.title,
        titleImgRoute: this.product.titleImgRoute,
        subtitle: this.product.subtitle,
        subsubtitle: this.product.subsubtitle,
        videoSrc: this.product.videoSrc
      }
      this.specs = SPECS.find(s => s.product === slug)?.specs ?? [];
      if (this.allowedSpecsArray.includes(slug ?? "")) {
        this.shouldShowSpecs = true
      }

    }

    scrollSpecs () {
      this.specsBox.nativeElement.scrollIntoView({
        behavior: 'smooth',
      })
    }

    scrollMain() {
      this.mainBox.nativeElement.scrollIntoView({
        behavior: 'smooth',
      })
    }
}
